import React from 'react';
import { Facebook, Instagram, Youtube, Linkedin, Twitter, Mail, Phone, Github, MessageCircle, Send } from 'lucide-react';
import './TopSocialBar.css';

const TopSocialBar = () => {
  // Hardcoded social media links - always visible
  const socialLinks = [
    {
      id: 1,
      platform: 'Telegram',
      url: 'https://t.me/Adhvaacademy',
      icon: Send,
      color: '#26A5E4',
      active: true
    },
    {
      id: 2,
      platform: 'Instagram',
      url: 'https://instagram.com/adhvaacademy',
      icon: Instagram,
      color: '#E4405F',
      active: true
    },
    {
      id: 3,
      platform: 'YouTube',
      url: 'https://youtube.com/@adhvaacademy',
      icon: Youtube,
      color: '#FF0000',
      active: true
    }
  ];

  const contactInfo = [
    {
      type: 'email',
      value: 'adhvaacademy@gmail.com',
      icon: Mail,
      href: 'mailto:adhvaacademy@gmail.com',
      ariaLabel: 'Send us an email'
    },
    {
      type: 'phone',
      value: '+91 88671 98007 / +91 88671 93007',
      icon: Phone,
      href: 'tel:+918867198007',
      ariaLabel: 'Call us'
    }
  ];

  return (
    <div className="top-social-bar">
      <div className="top-social-bar-content">
        {/* Contact Info - Left Side */}
        <div className="contact-info">
          {contactInfo.map((contact) => {
            const IconComponent = contact.icon;
            return (
              <a
                key={contact.type}
                href={contact.href}
                className="contact-link"
                aria-label={contact.ariaLabel}
                title={contact.ariaLabel}
              >
                <IconComponent size={14} />
                <span>{contact.value}</span>
              </a>
            );
          })}
        </div>

        {/* Social Media Links - Right Side */}
        <div className="social-links-bar">
          {socialLinks.length > 0 && <span className="follow-text">Follow Us:</span>}
          {socialLinks.filter(social => social.active).map((social) => {
            const IconComponent = social.icon;
            return (
              <a
                key={social.id}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                style={{ 
                  '--icon-color': social.color,
                  '--hover-color': social.color
                }}
                aria-label={`Visit our ${social.platform} page`}
                title={social.platform}
              >
                <IconComponent size={16} />
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TopSocialBar;
